import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

// Standard cn() helper. Use everywhere class names are conditionally
// assembled so Tailwind's last-wins conflict resolution works correctly.
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
